import { gql } from "@apollo/client";
import { print } from "@apollo/client/utilities";

export const DELETE_QUERY = print(gql`
  mutation CreateSubject($id: Int!) {
    deleteSubject(id: $id) {
      id
    }
  }
`);

export interface DeleteGql {
  deleteSubject: {
    id?: number;
  };
}
